import type { ReactNode } from "react";

import { pathToAuthLogout } from "@/src/app/paths";
import { buttonClassName } from "@/src/components/ui/Button/buttonClassName";

export function LogoutButton(): ReactNode {
  // Not a <Link>: prefetching would sign the user out
  // (https://github.com/auth0/nextjs-auth0/issues/757)
  return (
    <a
      className={buttonClassName(
        "block w-full max-w-80",
        true,
        false,
        "medium",
      )}
      href={pathToAuthLogout}
    >
      Me déconnecter
    </a>
  );
}
